var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7794 1.70404L17.8916 6.85166L18.8856 5.85764L12.7794 0L6.53125 5.96414L7.52528 6.95816L12.7794 1.70404Z",
    fill: "#E9E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.1406 14.5198H21.3006V11.6797H24.1406V14.5198ZM24.1406 18.7799H21.3006V15.9398H24.1406V18.7799ZM19.8805 14.5198H17.0405V11.6797H19.8805V14.5198ZM19.8805 18.7799H17.0405V15.9398H19.8805V18.7799ZM15.2654 14.5198H10.2953V13.0998H15.2654V14.5198ZM12.7803 7.77463C13.3839 7.77463 13.8454 8.23614 13.8454 8.83965C13.8454 9.44317 13.3839 9.90468 12.7803 9.90468C12.1768 9.90468 11.7153 9.44317 11.7153 8.83965C11.7153 8.23614 12.1768 7.77463 12.7803 7.77463ZM8.52023 14.5198H5.68015V11.6797H8.52023V14.5198ZM8.52023 18.7799H5.68015V15.9398H8.52023V18.7799ZM4.26011 14.5198H1.42004V11.6797H4.26011V14.5198ZM4.26011 18.7799H1.42004V15.9398H4.26011V18.7799ZM17.0405 9.90468V7.77463L12.7803 3.51453L8.52023 7.77463V9.90468H0V21.975H10.2953V18.0699C10.2953 17.0758 11.0053 15.9398 12.7803 15.9398C14.5554 15.9398 15.2654 17.0758 15.2654 18.0699V21.975H25.5607V9.90468H17.0405Z",
    fill: "#E9E9F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClub);
export default __webpack_public_path__ + "static/media/icon-club.afd46c0afc64e006721d9add5efe528b.svg";
export { ForwardRef as ReactComponent };